import React from 'react'
import AdmMostCirculated from '../../components/AdminTabs/AdminMostCirculated/AdmMostCirculated'

const MostCirculated = () => {
  return (
    <div>
      <AdmMostCirculated/>
    </div>
  )
}

export default MostCirculated
